<template>
  <div style="position: relative; width: 250px; margin: 0 auto" :class="classes">
    <c-img width="250px" src="img/mac-plus.png" />
    <div :style="screenshotBackgroundStyle" class="screenshot-overlay" />
  </div>
</template>

<script>
export default {
  name: 'MacPlus',
  props: {
    screenshotUrl: String,
    classes: String,
  },
  computed: {
    screenshotBackgroundStyle() {
      return `background: url('${this.screenshotUrl}')`;
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.screenshot-overlay {
  height: 125px;
  width: 166px;
  border-radius: 12px;
  background-size: cover !important;
  background-repeat: no-repeat !important;
  position: absolute;
  top: 52px;
  left: 42px;
  border: 3px solid black;
  background-position: center !important;
}
</style>
